import * as yup from 'yup';

import type { TFunction } from 'i18next';

const isBeforeToday = (isoDate?: string) => {
  if (!isoDate) {
    return false;
  }
  const today = new Date();
  return new Date(isoDate) < today;
};

export const validation = (t: TFunction<['common', 'validation', 'funnel']>) =>
  yup.object().shape({
    name: yup.string().required(t('validation:required')),
    id: yup.object().shape({
      value: yup
        .string()
        .required(t('validation:required'))
        .test('siretIsExactly14digits', t('validation:company_details_siret'), (value) => {
          const SIRET_DIGITS_COUNT = 14;
          return value?.replace(/\s/g, '').length === SIRET_DIGITS_COUNT;
        }),
    }),
    foundingDate: yup
      .string()
      .matches(/^[12]\d{3}-[01]\d-[0-3]\d$/, t('validation:company_details_date_format'))
      .test('is-before-today', t('validation:company_details_date'), isBeforeToday)
      .required(t('validation:required')),
    legalStructureCode: yup.object().shape({
      value: yup.string().required(t('validation:required')),
    }),
  });
